import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export function HomesFooter() {
  return (
    <footer className="mt-16 bg-[#0F172A] text-white/80" data-testid="homes-footer">
      <div className="mx-auto grid max-w-[1400px] gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10">
              <Home className="h-4 w-4 text-[#2563EB]" />
            </span>
            <span className="text-xl font-black text-white">Homes<span className="text-[#2563EB]">Pulse</span></span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-white/60">
            Find your home. Know your community. A place-first real-estate network powered by the USAPulse geographic graph.
          </p>
        </div>
        <FooterCol title="Discover" links={[
          ["Homes for Sale", "/homes/search?status=for_sale"],
          ["Homes for Rent", "/homes/search?status=for_rent"],
          ["Find an Agent", "/homes/agents"],
          ["Explore Places", "/explore/states"],
        ]} />
        <FooterCol title="Resources" links={[
          ["Buying Guide", "/homes/search?status=for_sale"],
          ["Renting Guide", "/homes/search?status=for_rent"],
          ["Market Overview", "/homes"],
          ["USAPulse Network", "/"],
        ]} />
        <div>
          <div className="mb-3 text-xs font-bold uppercase tracking-widest text-white/50">About</div>
          <p className="text-sm text-white/60">
            Listings shown are <b className="text-white/80">sample demonstration data</b>. HomesPulse does not display MLS/IDX data without proper agreements.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © 2026 HomesPulse.pro · Part of the USAPulse network · Fair Housing compliant
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="mb-3 text-xs font-bold uppercase tracking-widest text-white/50">{title}</div>
      <ul className="space-y-2">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-white/70 transition-colors hover:text-[#2563EB]">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
